import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

import { Button } from '../../../common/Atoms/Button';
import { Divider } from '../../../common/Atoms/Divider';
import { Modal } from '../../../common/Atoms/Modal';
import { Paragraph } from '../../../common/Atoms/Typography/Paragraph';

interface ISmsBillingModalProps {
  show: boolean;
  enabled: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLoading?: boolean;
}

export function SmsBillingModal({
  show,
  enabled,
  onConfirm,
  onCancel,
  confirmLoading,
}: ISmsBillingModalProps) {
  const nextStateLabel = enabled ? `Disable` : `Enable`;

  return (
    <Modal
      setOpen={ onCancel }
      open={ show }
      title={ `${nextStateLabel} SMS billing` }
      icon={ <ExclamationTriangleIcon className={ `text-orange-500 h-5 w-5` } /> }
    >
      <div>
        <Divider
          weight={ `light` }
          spacing={ `small` }
        />

        <div className={ `space-y-2` }>
          <Paragraph variant={ `primary` }>
            { `SMS is billed separately based on message usage and length at your subscription currency rate per message/part.` }
          </Paragraph>
          <Paragraph
            variant={ `primary` }
          >
            { `Charges will occur after one month or when 250 messages have been sent and charged to your default payment method.` }
          </Paragraph>
          <Paragraph variant={ `help` }>
            { `You can limit the number of SMS sent per month with the SMS Monthly Limit.` }
          </Paragraph>
        </div>

        <div className={ `mt-4 flex justify-center space-x-4` }>
          <Button
            color={ enabled ? `orange` : `paidniceGreen` }
            onClick={ onConfirm }
            loading={ confirmLoading }
            disabled={ confirmLoading }
          >
            { `${nextStateLabel} SMS billing` }
          </Button>

          <Button
            color={ `gray` }
            onClick={ onCancel }
            disabled={ confirmLoading }
          >
            { `Cancel` }
          </Button>
        </div>
      </div>
    </Modal>
  );
}
